import { memo } from 'react';
import dayjs from 'dayjs';
import { ICluster, IContent } from 'src/interface';
import { formatTime } from 'src/utils/date';
import { Element, Icon, RouterLink as Link, RouterLink } from 'src/components';
import { ContentPublisher } from 'src/modules/content/components/shared/ContentPublisher';
import { ContentCluster } from 'src/modules/content/components/shared/ContentCluster';
import styles from './style.module.scss';

interface IProps {
    content: IContent;
}

const ContentMeta = ({ content = {} as IContent }: IProps) => {
    const { publishedDate, cluster, duplicate, publisher } = content;
    return (
        <Element className={styles['content-meta']}>
            {publisher && (
                <RouterLink to={publisher.url}>
                    <ContentPublisher
                        publisher={publisher}
                        hStyle={20}
                        lazyloadImage={false}
                    />
                </RouterLink>
            )}

            {publishedDate && (
                <Element
                    renderAs="time"
                    dateTime={dayjs(publishedDate * 1000).toISOString()}
                >
                    {formatTime(publishedDate, ' trước')}
                </Element>
            )}
            {duplicate && (
                <Link to={duplicate.url}>
                    <Element renderAs="span">
                        {duplicate.total} đăng lại
                    </Element>
                </Link>
            )}
            <ContentCluster cluster={cluster as ICluster} />
            <RouterLink
                to={content.redirectUrl}
                className={styles['source-origin']}
                newTab={true}
            >
                <Icon icon="copy" />
                <Element renderAs="span">Gốc</Element>
            </RouterLink>
        </Element>
    );
};

export default memo(ContentMeta);
